import { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ContextApp } from '../../context';

const Header = ({ listLinks }) => {
    return (
        <header className='header'>
            <div className='container'>
                <div className='header__inner'>
                    <Link className='header__logo' to='/?page=1'>
                        FILM<span className='header__logo-phrase'>IK</span>
                    </Link>
                    <nav className='header__nav'>
                        {listLinks}
                    </nav>
                </div>
            </div>
        </header>
    );
};

Header.propTypes = {
    listLinks: PropTypes.array.isRequired,
};

const HeaderContainer = () => {
    const { state: { favoritesMoviesId, favoritesPremieresId } } = useContext(ContextApp);

    const dataLinks = [
        { title: 'Главная', to: '?page=1', desiredMatch: '' },
        { title: 'Фильмы', to: '?type=film&page=1', desiredMatch: 'type=film' },
        { title: 'Сериалы', to: '?type=series&page=1', desiredMatch: 'type=series' },
        { title: 'Мультфильмы', to: '?type=cartoon&page=1', desiredMatch: 'type=cartoon' },
        { title: 'Премьеры', to: 'premieres?page=1', desiredMatch: '' },
        { title: 'Отслеживаемое', to: 'favorites', desiredMatch: '' },
    ];

    const listLinks = dataLinks.map((dataLink) => {
        let favorites;

        if (dataLink.title === 'Отслеживаемое') {
            favorites = <span className='header__nav-span'>{favoritesMoviesId.length + favoritesPremieresId.length}</span>;
        }
        return (
            <NavLink className='header__nav-link' key={dataLink.title} activeClassName='header__nav-link--active' to={`/${dataLink.to}`} isActive={(_, location) => {
                if ((location.pathname === '/' && !location.search.includes('type=') && dataLink.title === 'Главная') || (location.pathname === '/premieres' && dataLink.title === 'Премьеры') || (location.pathname === '/favorites' && dataLink.title === 'Отслеживаемое')) {
                    return true;
                }

                return dataLink.desiredMatch && location.search.includes(dataLink.desiredMatch);
            }
            }>{dataLink.title}{favorites}</NavLink>);
    });

    return (
        <Header listLinks={listLinks} />
    );
};

export default HeaderContainer;